(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {

  const blogGrid = document.getElementById("blog-grid");
  const loadMoreBtn = document.getElementById("loadMore");
  const loadMoreContainer = document.getElementById("load-more-container");
  const paginationData = document.getElementById("blog-pagination-data");

  if (!blogGrid || !loadMoreBtn || !paginationData) {
    return;
  }


  /* =========================================
     SETTINGS
  ========================================== */

  const cardsPerClick = 6;

  let currentVisibleCount = 0;

  let isLoadingNextPage = false;

  let nextPageUrl =
    paginationData.getAttribute("data-next-page-url") || "";

  let currentPage =
    parseInt(
      paginationData.getAttribute("data-current-page") || "1",
      10
    );

  let totalPages =
    parseInt(
      paginationData.getAttribute("data-total-pages") || "1",
      10
    );


  /* =========================================
     GET CURRENT BLOG CARDS
  ========================================== */

  function getBlogCards() {

    return blogGrid.querySelectorAll(".blog-card");

  }


  /* =========================================
     SHOW NEXT 6 BLOGS
  ========================================== */

  function showNextCards() {

    const cards = getBlogCards();

    let shown = 0;

    for (
      let i = currentVisibleCount;
      i < cards.length && shown < cardsPerClick;
      i++
    ) {

      cards[i].style.display = "block";

      shown++;

    }

    currentVisibleCount += shown;

    return shown;

  }


  /* =========================================
     UPDATE BUTTON
  ========================================== */

  function updateButton() {

    const cards = getBlogCards();

    /*
      If there are still hidden cards
      on the current page
    */

    if (currentVisibleCount < cards.length) {

      loadMoreContainer.style.display = "block";

      loadMoreBtn.style.display = "inline-block";

      loadMoreBtn.disabled = false;

      loadMoreBtn.querySelector(".load-more-text").style.display =
        "inline";

      loadMoreBtn.querySelector(".load-more-spinner").style.display =
        "none";

      return;

    }


    /*
      If current page is finished,
      check if another Shopify page exists
    */

    if (nextPageUrl) {

      loadMoreContainer.style.display = "block";

      loadMoreBtn.style.display = "inline-block";

      loadMoreBtn.disabled = false;

      loadMoreBtn.querySelector(".load-more-text").textContent =
        "Load More";

      return;

    }


    /*
      Nothing else to load
    */

    loadMoreContainer.style.display = "none";

  }


  /* =========================================
     LOADING STATE
  ========================================== */

  function setLoadingState(isLoading) {

    if (isLoading) {

      loadMoreBtn.disabled = true;

      loadMoreBtn.querySelector(".load-more-text").style.display =
        "none";

      loadMoreBtn.querySelector(".load-more-spinner").style.display =
        "inline";

    } else {

      loadMoreBtn.disabled = false;

      loadMoreBtn.querySelector(".load-more-text").style.display =
        "inline";

      loadMoreBtn.querySelector(".load-more-spinner").style.display =
        "none";

    }

  }


  /* =========================================
     FETCH NEXT SHOPIFY PAGE
  ========================================== */

  async function loadNextPage() {

    if (!nextPageUrl || isLoadingNextPage) {
      return;
    }

    isLoadingNextPage = true;

    setLoadingState(true);


    try {

      /*
        Fetch Shopify page 2 / page 3 etc.
      */

      const response = await fetch(nextPageUrl, {
        method: "GET",
        headers: {
          "X-Requested-With": "XMLHttpRequest"
        }
      });


      if (!response.ok) {

        throw new Error(
          "Unable to load the next blog page."
        );

      }


      const html = await response.text();


      /*
        Convert response into HTML
      */

      const parser = new DOMParser();

      const doc = parser.parseFromString(
        html,
        "text/html"
      );


      /*
        Find blog grid from fetched page
      */

      const newGrid =
        doc.querySelector("#blog-grid");


      if (!newGrid) {

        throw new Error(
          "Blog grid was not found."
        );

      }


      /*
        Find new blog cards
      */

      const newCards =
        newGrid.querySelectorAll(".blog-card");


      /*
        If no cards are found,
        stop loading
      */

      if (!newCards.length) {

        nextPageUrl = "";

        updateButton();

        return;

      }


      /*
        Append each new card
        into current blog grid
      */

      newCards.forEach(function (card) {

        /*
          Keep new cards hidden initially.
          They will be shown 6 at a time.
        */

        card.style.display = "none";

        blogGrid.appendChild(
          card.cloneNode(true)
        );

      });


      /*
        Find pagination information
        from fetched page
      */

      const newPagination =
        doc.querySelector("#blog-pagination-data");


      if (newPagination) {

        nextPageUrl =
          newPagination.getAttribute(
            "data-next-page-url"
          ) || "";

        currentPage =
          parseInt(
            newPagination.getAttribute(
              "data-current-page"
            ) || (currentPage + 1),
            10
          );

      } else {

        nextPageUrl = "";

      }


      /*
        Show next 6 newly loaded blogs
      */

      showNextCards();

      updateButton();


    } catch (error) {

      console.error(
        "Blog Load More Error:",
        error
      );


      /*
        If fetching fails,
        allow user to retry.
      */

      loadMoreBtn.querySelector(
        ".load-more-text"
      ).textContent = "Try Again";


    } finally {

      isLoadingNextPage = false;

      setLoadingState(false);

      updateButton();

    }

  }


  /* =========================================
     LOAD MORE BUTTON CLICK
  ========================================== */

  loadMoreBtn.addEventListener(
    "click",
    function () {

      const cards = getBlogCards();


      /*
        First show hidden blogs
        from current page.
      */

      if (currentVisibleCount < cards.length) {

        showNextCards();

        updateButton();

        return;

      }


      /*
        Current page finished,
        load Shopify's next page.
      */

      if (nextPageUrl) {

        loadNextPage();

      } else {

        updateButton();

      }

    }
  );


  /* =========================================
     INITIAL LOAD
     Show first 6 blogs
  ========================================== */

  showNextCards();

  updateButton();

});


  } catch(e) { console.error(e); }
})();
})();
